import { useEffect, useState } from 'react';

/**
 * The value, settled: it only changes once `value` has held still for `ms`.
 *
 * Search boxes feed this so a list fetch runs once per pause in typing rather than once per
 * keystroke - "membrane" is one request, not eight, and never eight racing each other.
 */
export default function useDebounced(value, ms) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}
